import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'OfflineMixin',
})
export default class OfflineMixin extends Vue {
  online = false;

  public mounted(): void {
    if (typeof window === 'undefined') {
      return;
    }

    this.online = navigator.onLine;

    const onlineHandler = () => {
      this.$emit('online');
      this.online = true;
    };

    const offlineHandler = () => {
      this.$emit('offline');
      this.online = false;
    };

    window.addEventListener('online', onlineHandler);
    window.addEventListener('offline', offlineHandler);

    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('online', onlineHandler);
      window.removeEventListener('offline', offlineHandler);
    });
  }
}
